import { Box } from "@mui/material";
import CustomInputCell from "./CustomInputCell";
import { fullHeadBorder, leftBorder, rightBorder } from "./colsBorders";

export const taggedMrqMaterialsColsEdit = (onChange = () => {}) => [
  {
    accessorKey: "tagNumbers",
    header: "Part/Tag/Mark #",
    enableEditing: false,
    size: 200,
    Cell: ({ row }) => {
      return (
        <Box>
          {row.original.materials?.map((m, i) => {
            return (
              m.taggedMaterial?.tagNumber + ", "
              // <p key={i}>
              //   - {m.taggedMaterial?.tagNumber || m.bulkMaterial?.item}
              // </p>
            );
          })}
        </Box>
      );
    },
  },
  {
    header: "Description",
    accessorKey: "description",
    enableEditing: false,
    size: 400,
  },
  {
    header: "Req. Quantity",
    accessorKey: "reqQty",
    enableEditing: false,
    size: 20,
    Cell: ({ row }) => {
      return <Box>{row.original.materials?.length}</Box>;
    },
  },
  {
    accessorKey: "procuredQty",
    header: "Procured Qty",
    enableEditing: false,
    grow: false,
    size: 10,
    Cell: ({ row }) => {
      return (
        <CustomInputCell
          name="procuredQty"
          row={row}
          onChange={onChange}
          placeholder="Add Quantity"
        />
      );
    },
  },
  {
    header: "Unit",
    accessorKey: "unit",
    enableEditing: false,
    size: 50,
    Cell: ({ row }) => {
      const isPlate = row.original?.description
        ?.toLowerCase()
        .includes("plate");
      const isPipe = row.original?.description?.toLowerCase().includes("pipe");
      const isHead = row.original?.costCode?.toLowerCase().includes("head");

      // console.log("poManager", row.original);
      if (row.original.unit) {
        return row.original.unit;
      } else if (isPipe && !isHead) {
        return "mm";
      } else {
        return "Nos";
      }
    },
  },
  {
    accessorKey: "remarks",
    header: "Remarks",
    enableEditing: false,
    grow: false,
    size: 200,
    ...rightBorder,
    Cell: ({ row }) => {
      return (
        <CustomInputCell
          name="remarks"
          row={row}
          onChange={onChange}
          type="string"
        />
      );
    },
  },
];

export const taggedMrqMaterialsCols = [
  {
    header: "Materials",
    columns: [
      {
        accessorKey: "tagNumbers",
        header: "Part/Tag/Mark #",
        enableEditing: false,
        size: 100,
        Cell: ({ row }) => {
          // console.log("row", row.original);
          return (
            <Box>
              {row.original.materials?.map((m, i) => {
                return (
                  // m.bulkMaterial?.item + ", "
                  <p key={i}>
                    - {m.taggedMaterial?.tagNumber || m.bulkMaterial?.item}
                  </p>
                );
              })}
            </Box>
          );
        },
      },
      // {
      //   accessorKey: "costCode",
      //   header: "Cost Code",
      //   enableEditing: false,
      //   grow: false,
      //   size: 60,
      // },
      {
        header: "Description",
        accessorKey: "description",
        enableEditing: false,
        size: 250,
      },

      {
        header: "Procured Qty",
        accessorKey: "procuredQty",
        enableEditing: false,
        size: 20,
      },
      {
        header: "Unit",
        accessorKey: "unit",
        enableEditing: false,
        size: 50,
        Cell: ({ row }) => {
          const isPlate = row.original?.description
            ?.toLowerCase()
            .includes("plate");
          const isPipe = row.original?.description
            ?.toLowerCase()
            .includes("pipe");
          const isHead = row.original?.costCode?.toLowerCase().includes("head");

          // console.log("poManager", row.original);
          if (row.original.unit) {
            return row.original.unit;
          } else if (isPipe && !isHead) {
            return "mm";
          } else {
            return "Nos";
          }
        },
      },
    ],
  },
  // {
  //   header: "Payment",
  //   accessorKey: "payment",
  //   enableEditing: false,

  //   columns: [
  //     {
  //       header: "Amount",
  //       accessorKey: "initAmount",
  //       enableEditing: false,
  //       size: 10,
  //     },
  //     {
  //       header: "Date",
  //       accessorKey: "initDate",
  //       enableEditing: false,
  //       size: 80,
  //     },
  //     {
  //       header: "Amount",
  //       accessorKey: "arrivedAmount",
  //       enableEditing: false,
  //       size: 10,
  //     },
  //     {
  //       header: "Date",
  //       accessorKey: "arrivedDate",
  //       enableEditing: false,
  //       size: 80,
  //     },
  //     {
  //       header: "Amount",
  //       accessorKey: "after30Amount",
  //       enableEditing: false,
  //       size: 10,
  //     },
  //     {
  //       header: "Date",
  //       accessorKey: "after30Date",
  //       enableEditing: false,
  //       size: 80,
  //     },
  //   ],
  // },

  {
    header: "Cost",
    accessorKey: "s",
    columns: [
      {
        header: "Cost / unit $",
        accessorKey: "cost",
        enableEditing: false,
        size: 30,
      },
      {
        header: "Total Cost $",
        accessorKey: "totalCost",
        enableEditing: false,
        size: 30,
        Cell: ({ row }) => {
          return row.original.cost * row.original.procuredQty;
        },
      },
    ],
  },
  {
    header: "Remarks",
    accessorKey: "remarks",
    enableEditing: false,
    size: 30,
  },
];

export const bulkMrqMaterialsCols = [
  {
    accessorKey: "bulkMaterial.item",
    header: "Items",
    enableEditing: false,
    grow: false,
    size: 50,
    Cell: ({ row }) => {
      console.log({ row: row.original });
      return (
        <Box>
          {row.original.materials
            ?.map((m) => m?.bulkMaterial?.item)
            .sort()
            .map((item, i) => {
              return <p key={i}>- {item}</p>;
            })}
        </Box>
      );
    },
  },
  {
    accessorKey: "quantity",
    header: "Quantity",
    enableEditing: false,
    grow: false,
    size: 50,
    Cell: ({ row }) => {
      const qty = row.original?.quantity;

      function formatNumber(num) {
        return Number.isInteger(num) ? num : num.toFixed(2);
      }

      return formatNumber(Number(qty));
    },
  },
  {
    accessorKey: "materialCode",
    header: "Material Code",
    enableEditing: false,

    size: 120,
  },
  {
    accessorKey: "description",
    header: "Description",
    enableEditing: false,

    size: 120,
  },
];

export const bulkDescriptionMrqMaterialsColsEdit = (onChange = () => {}) => [
  {
    accessorKey: "Consolidation Data",
    header: "Consolidation Data",
    ...fullHeadBorder,
    columns: [
      {
        accessorKey: "markNumber",
        header: "Mark #",
        enableEditing: false,
        grow: false,
        size: 150,
        ...leftBorder,
        Cell: ({ row }) => {
          // console.log({ row: row.original });
          return (
            <Box>
              {row.original.materials
                ?.map((m) => m?.bulkMaterial?.markNumber || m?.markNumber)
                .sort()
                .map((markNumber, i) => {
                  return <p key={i}>- {markNumber}</p>;
                })}
            </Box>
          );
        },
      },
      {
        accessorKey: "costCode",
        header: "Cost Code",
        enableEditing: false,
        grow: false,
        size: 60,
        Cell: ({ row }) => {
          return <Box>{row.original.materials?.[0]?.costCode}</Box>;
        },
      },
      {
        accessorKey: "description",
        header: "Description",
        enableEditing: false,

        size: 230,
      },

      {
        accessorKey: "length",
        header: "Dimension",
        enableEditing: false,
        grow: false,
        size: 10,
        ...leftBorder,
        Cell: ({ row }) => {
          console.log("row", row.original);
          const isPipe = row.original?.description
            ?.toLowerCase()
            .includes("pipe");
          const isPlate = row.original?.description
            ?.toLowerCase()
            .includes("plate");

          let qty = 0;

          row.original.materials?.forEach((m) => {
            // console.log("mmmmmmm", m.quantity, m.length);
            if (!isPlate) qty += Number(m?.length) * Number(m?.quantity) || 0;
          });
          function formatNumber(num) {
            return Number.isInteger(num) ? num : num.toFixed(2);
          }

          // console.log("qty", qty);
          return isPlate ? (
            <CustomInputCell
              name="length"
              row={row}
              onChange={onChange}
              type="string"
              placeholder="Add Dimension"
            />
          ) : qty !== 0 ? (
            formatNumber(Number(qty))
          ) : (
            ""
          );
        },
      },

      {
        accessorKey: "unit",
        header: "Unit",
        enableEditing: false,
        size: 60,
        ...rightBorder,
        Cell: ({ row }) => {
          const isPlate = row.original?.description
            ?.toLowerCase()
            .includes("plate");
          const isPipe = row.original?.description
            ?.toLowerCase()
            .includes("pipe");
          const isHead = row.original?.costCode?.toLowerCase().includes("head");

          const unit = row.original?.unit;

          if (unit) {
            return unit;
          } else if (isPlate && !isHead) {
            return (
              <CustomInputCell
                name="unit"
                row={row}
                onChange={onChange}
                type="string"
              />
            );
          } else if (isPipe && !isHead) {
            return "mm";
          } else {
            return "Nos";
          }
        },
      },
    ],
  },
  // ------------------------------------- Procured Data -------------------------------------

  {
    accessorKey: "Procurement Data",
    header: "Procurement Data",
    ...fullHeadBorder,
    columns: [
      {
        accessorKey: "reqQty",
        header: "Req. Qty",
        enableEditing: false,
        grow: false,
        size: 10,
        ...leftBorder,
        ...rightBorder,
        Cell: ({ row }) => {
          return (
            <CustomInputCell
              name="reqQty"
              row={row}
              onChange={onChange}
              placeholder="Req Quantity"
            />
          );
        },
      },
      {
        accessorKey: "procuredQty",
        header: "Procured Qty",
        enableEditing: false,
        grow: false,
        size: 10,
        Cell: ({ row }) => {
          return (
            <CustomInputCell
              name="procuredQty"
              row={row}
              onChange={onChange}
              placeholder="Add Quantity"
            />
          );
        },
      },
      {
        accessorKey: "procuredUnit",
        header: "Unit",
        enableEditing: false,
        grow: false,
        size: 10,
        ...rightBorder,
        Cell: () => {
          return "Ft";
        },
      },
      {
        accessorKey: "remarks",
        header: "Remarks",
        enableEditing: false,
        grow: false,
        size: 200,
        ...rightBorder,
        Cell: ({ row }) => {
          return (
            <CustomInputCell
              name="remarks"
              row={row}
              onChange={onChange}
              type="string"
            />
          );
        },
      },
    ],
  },
];

export const bulkDescriptionMrqMaterialsCols = [
  {
    accessorKey: "costCode",
    header: "Cost Code",
    enableEditing: false,
    grow: false,
    size: 60,
    Cell: ({ row }) => {
      return <Box>{row.original.materials?.[0]?.costCode}</Box>;
    },
  },
  {
    accessorKey: "description",
    header: "Description",
    enableEditing: false,

    size: 230,
  },

  {
    accessorKey: "unit",
    header: "Unit",
    enableEditing: false,

    size: 60,
    Cell: ({ row }) => {
      return "Ft";
      // const isPlate = row.original?.description
      //   ?.toLowerCase()
      //   .includes("plate");
      // const isPipe = row.original?.description?.toLowerCase().includes("pipe");
      // const isHead = row.original?.costCode?.toLowerCase().includes("head");

      // if (row.original.unit) {
      //   return row.original.unit;
      // } else if (isPipe && !isHead) {
      //   return "mm";
      // } else {
      //   return "Nos";
      // }
    },
  },

  {
    accessorKey: "procuredQty",
    header: "Procured Qty",
    enableEditing: false,
    grow: false,
    size: 10,
  },
  {
    accessorKey: "remarks",
    header: "Remarks",
    enableEditing: false,
    grow: false,
    size: 250,
  },
];
